import React, { Component } from 'react';
import { currency } from './../../../helpers/';

class CheckoutItem extends Component {
	constructor () {
		super();
		this.state = { toggle : false };
	}

	confirmRemove() {
		this.setState({ toggle : false });
		this.props.removeItem();
	};

	list(){
		if( this.props.removeItem ){
			return (
				<ul className="buttons-right">
					<li>
						<button className="btn btn-warning" type="button" onClick={() => this.state.toggle ? this.confirmRemove() : this.setState({ toggle : true })}>
							<span className="icon"><i className="fa fa-trash fa-left" /></span>
							<span className="label">{ this.state.toggle ? 'Confirm' : 'Remove' }</span>
						</button>
					</li>
				</ul>
			);
		};
	}

	render() {
		return (
			<div className='single-basket-item'>
				<div className="col-xs-12">
					<hr />
				</div>
				<div className="col-xs-9 col-sm-7 col-lg-8 basket-item-description">
					<h5 className="h5">{ this.props.name }</h5>
				</div>
				<p className="p-tag col-xs-3 col-sm-2 col-lg-2 basket-item-price">{ currency.convert( this.props.price ) }</p>
				{ !this.props.firstLoginPurchaseView ? <div className="col-xs-12 col-sm-3 col-lg-2 basket-item-remove">{ this.list() }</div> : null }
			</div>
		);
	};
}

export default CheckoutItem;



// WEBPACK FOOTER //
// src/client/components/common/transactions/CheckoutItem.js